
import Clarity from "@microsoft/clarity";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import Form from "./form/Form";

export default function ProfileEditDoctor() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const [profile, setProfile] = useState(null);
	const [doctor, setDoctor] = useState(null);
	const [errorMessage, setErrorMessage] = useState("");
	const profileId = LoginHelper.getProfileId();
	const linkDataList = [
		{ label: "خانه", href: "/" },
		...(profileId
			? [{ label: "پروفایل", href: "/profile/" + profileId + "/" }]
			: []),
		{ label: "ویرایش درمانگر", href: "/profile_edit_doctor/" },
	];

	useEffect(() => {
		fetchDoctor();
	}, []);

	function fetchDoctor() {
		api.doctorFetchEdit({
			token: LoginHelper.getToken(),
		})
			.then((result) => {
				if (result["profile"]) {
					setProfile(result["profile"]);
				}
				if (result["doctor"]) {
					setDoctor(result["doctor"]);
				}
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	const column = "mx-auto w-full max-w-[560px] px-4";

	return (
		<>
			<Helmet>
				<title>ویرایش درمانگر | همراهتیم</title>
				<meta name="description" content="ویرایش درمانگر همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white border-b border-[#E2E8F0]">
						<div className={column}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className={`${column} py-6 sm:py-8`}>
						{profile ? (
							<Form profile={profile} doctor={doctor} isDesktop={isDesktop} />
						) : null}
						{!profile && errorMessage ? (
							<p className="text-center font-Vazir-400 text-[14px] text-error mt-4">
								{errorMessage}
							</p>
						) : null}
					</div>
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
